


















import Vue, { PropType } from 'vue';
import TableSortIcons from '@/components/table/newTable/TableSortIcons.vue';
import { getSortColumn, getSortType } from '@/helpers/tableHelpers';
import TableService from '@/services/TableService';
import { Column } from '@/components/table/types';

export default Vue.extend({
  name: 'TableHeadCell',
  components: { TableSortIcons },

  props: {
    column: {
      type: Object as PropType<Column>,
      required: true,
    },
    sortedColumn: {
      type: String,
      required: true,
    },
  },

  watch: {
    sortedColumn: {
      handler() {
        this.checkSortedColumns();
      },
      immediate: true,
    },
  },

  computed: {
    sortType(): string {
      return getSortType(this.sortColumn);
    },
    useSort(): boolean {
      return !!this.column.useSort;
    },
  },

  methods: {
    sort() {
      if (!this.useSort) return;

      if (!this.sortColumn) {
        this.sortColumn = TableService.sortColumn(this.column.field);
      } else {
        this.sortColumn = TableService.changeSortColumn(this.sortColumn);
      }
      this.update();
    },
    checkSortedColumns() {
      const sortColumn = getSortColumn(this.sortedColumn);

      if (sortColumn !== this.column.field) {
        this.sortColumn = '';
      } else {
        this.sortColumn = this.sortedColumn;
      }
    },
    update() {
      this.$emit('update', this.sortColumn);
    },
  },

  data() {
    return {
      sortColumn: this.sortedColumn,
    };
  },
});
